import React from 'react';

interface PageHeadingButton {
  icon?: React.ReactNode;
  text: string;
  onClick?: () => void;
  isLoading?: boolean;
}

interface PageHeadingProps {
  text: string;
  textClass?: string;
  button?: PageHeadingButton;
}

const PageHeading = ({ text, button, textClass }: PageHeadingProps) => {
  return (
    <div className="flex flex-1 items-center justify-between mb-6 gap-3 flex-wrap">
      <h3 className={`text-xl font-semibold ${textClass}`}>{text}</h3>
      {button && (
        <button
          onClick={button.onClick}
          className="btn-primary flex items-center gap-2"
          disabled={button.isLoading}
        >
          {button.icon && (
            <span className={button.isLoading ? 'animate-spin' : ''}>
              {button.icon}
            </span>
          )}
          {button.text}
        </button>
      )}
    </div>
  );
};

export default PageHeading;
